<nz-footer>
  <nz-row [nzGutter]="[8, 8]">
    <nz-col>
      <nz-select
        (ngModelChange)="onLocaleSelectValueChanged($event)"
        [ngModel]="this.localeDTO"
        [nzAllowClear]="false"
        [nzDisabled]="1 === getAvailableLocales().length">
        @for (localeDTO of getAvailableLocales(); track localeDTO.value) {
          <nz-option
            [nzValue]="localeDTO"
            [nzLabel]="localeDTO.value | uppercase" />
        }
        >
      </nz-select>
    </nz-col>
    <nz-col
      [nzLg]="{ span: 12, offset: 0 }"
      [nzMd]="{ span: 18, offset: 0 }"
      [nzSm]="{ span: 22, offset: 0 }"
      [nzXs]="{ span: 22, offset: 0 }">
      <nz-row [nzGutter]="[0, 4]">
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('')"
              [rel]="'follow'"
              i18n="@@menu-viewing-tools-group-profile-viewer-item-title"
              >Profile viewer</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('story-viewer')"
              [rel]="'follow'"
              i18n="@@menu-viewing-tools-group-story-viewer-item-title"
              >Story viewer</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('video-downloader')"
              [rel]="'follow'"
              i18n="@@menu-downloading-tools-group-video-downloader-item-title"
              >Video downloader</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('reel-downloader')"
              [rel]="'follow'"
              i18n="@@menu-downloading-tools-group-reel-downloader-item-title"
              >Reels downloader</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('photo-downloader')"
              [rel]="'follow'"
              i18n="@@menu-downloading-tools-group-photo-downloader-item-title"
              >Photo downloader</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('avatar-downloader')"
              [rel]="'follow'"
              i18n="@@menu-downloading-tools-group-avatar-downloader-item-title"
              >Avatar downloader</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('about-project')"
              [rel]="'nofollow'"
              i18n="@@menu-technical-group-about-project-item-title"
              >About project</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('terms-and-conditions')"
              [rel]="'nofollow'"
              i18n="@@menu-technical-group-terms-and-conditions-item-title"
              >Terms and conditions</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('privacy-policy')"
              [rel]="'nofollow'"
              i18n="@@menu-technical-group-privacy-policy-item-title"
              >Privacy policy</a
            >
          </nz-tag>
        </nz-col>
        <nz-col>
          <nz-tag [nzBordered]="false" [nzMode]="'default'">
            <a
              [href]="getHref('cookie-policy')"
              [rel]="'nofollow'"
              i18n="@@menu-technical-group-cookie-policy-item-title"
              >Cookie policy</a
            >
          </nz-tag>
        </nz-col>
      </nz-row>
    </nz-col>
  </nz-row>
</nz-footer>
